import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollProps {
  top?: number;
}

const ScrollToTop = ({top = 0 }: ScrollProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo(0, top);
    });
  }, [pathname, top]);
  return null;
};

export default ScrollToTop;